import type { TimelineCapsule } from "./capsule.types";

export type CapsuleSummary = {
  capsuleId: string;
  title: string;
  laneCount: number;
  rangeSec: number;
  syncHealth: NonNullable<TimelineCapsule["summary"]>["syncHealth"];
  itemCount: number;
  warningCount: number;
  invalidationCount: number;
  awaitingCount: number;
};

export function summarizeCapsule(capsule: TimelineCapsule): CapsuleSummary {
  return {
    capsuleId: capsule.id,
    title: capsule.title,
    laneCount: capsule.laneIds.length,
    rangeSec: Math.max(0, capsule.endSec - capsule.startSec),
    syncHealth: capsule.summary?.syncHealth ?? "aligned",
    itemCount: capsule.summary?.itemCount ?? 0,
    warningCount: capsule.summary?.warningCount ?? 0,
    invalidationCount: capsule.summary?.invalidationCount ?? 0,
    awaitingCount: capsule.summary?.awaitingCount ?? 0,
  };
}